(() => {
  const STORAGE_KEY = 'noa-theme';
  const root = document.documentElement;

  const currentTheme = () => (root.getAttribute('data-theme') === 'light' ? 'light' : 'dark');

  const applyTheme = (theme) => {
    const next = theme === 'light' ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    root.style.colorScheme = next;
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (error) {
      /* private mode */
    }
    document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
      const nextLabel = next === 'light' ? button.dataset.labelToDark : button.dataset.labelToLight;
      if (nextLabel) button.setAttribute('aria-label', nextLabel);
      button.setAttribute('aria-pressed', next === 'light' ? 'true' : 'false');
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-theme-toggle]');
    if (!button) return;
    applyTheme(currentTheme() === 'dark' ? 'light' : 'dark');
  });

  applyTheme(currentTheme());

  const englishCountryNames = () => {
    if (!('Intl' in window) || !Intl.DisplayNames) return;
    const names = new Intl.DisplayNames(['en'], { type: 'region' });
    document.querySelectorAll('[data-country-iso]').forEach((el) => {
      const iso = el.getAttribute('data-country-iso');
      if (!iso) return;
      try {
        const label = names.of(iso);
        if (label) el.textContent = label;
      } catch (error) {
        /* keep ISO code */
      }
    });
  };

  const JP = /[\u3040-\u30ff\u4e00-\u9faf]/;
  const PHRASES = [
    ['プライバシーポリシー', 'Privacy policy'],
    ['利用規約', 'Terms of service'],
    ['返金ポリシー', 'Refund policy'],
    ['配送ポリシー', 'Shipping policy'],
    ['Cookie同意', 'Cookie consent'],
    ['設定を管理', 'Manage settings'],
    ['すべて受け入れる', 'Accept all'],
    ['受け入れ', 'Accept'],
    ['拒否', 'Decline'],
    ['最終更新日：', 'Last updated: '],
    ['アメリカ合衆国', 'United States'],
    ['shop でフォロー', 'Follow on Shop'],
    ['ショップでフォロー', 'Follow on Shop'],
    ['Shopでフォロー', 'Follow on Shop'],
    ['shopでフォロー', 'Follow on Shop'],
  ];

  const toEnglish = (value) => {
    if (!value || !JP.test(value)) return value;
    let next = value;
    PHRASES.forEach(([from, to]) => {
      next = next.split(from).join(to);
    });
    if (/Cookie|cookie|Shopify/.test(next) && JP.test(next)) {
      return 'This store and partners such as Shopify use cookies to personalize your visit, measure performance, and show relevant ads. See our Privacy policy for details.';
    }
    return next;
  };

  const translateNode = (node) => {
    if (!node) return;
    if (node.nodeType === Node.TEXT_NODE) {
      const next = toEnglish(node.textContent);
      if (next !== node.textContent) node.textContent = next;
      return;
    }
    if (node.shadowRoot) node.shadowRoot.childNodes.forEach(translateNode);
    node.childNodes.forEach(translateNode);
  };

  const englishCookieBanner = () => {
    document.title = toEnglish(document.title);
    const banner =
      document.getElementById('shopify-pc__banner') ||
      document.querySelector('shopify-privacy-banner') ||
      document.querySelector('#shopify-consent-banner');
    if (banner) translateNode(banner);
  };

  const englishFollowOnShop = () => {
    document.querySelectorAll('shop-follow-button').forEach((el) => {
      el.setAttribute('locale', 'en');
      translateNode(el);
    });
  };

  const boot = () => {
    englishCountryNames();
    englishCookieBanner();
    englishFollowOnShop();
    window.setTimeout(englishCookieBanner, 800);
    window.setTimeout(englishFollowOnShop, 600);
    window.setTimeout(englishFollowOnShop, 2000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
